import { render, staticRenderFns } from "./ShowNotes.vue?vue&type=template&id=7d210a4c&scoped=true&"
import script from "./ShowNotes.vue?vue&type=script&lang=js&"
export * from "./ShowNotes.vue?vue&type=script&lang=js&"
import style0 from "./ShowNotes.vue?vue&type=style&index=0&id=7d210a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d210a4c",
  null
  
)

export default component.exports